// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mt-rating__order_by{align-items:center;display:flex;height:40px;justify-content:flex-end;max-width:130px;width:100%}.mt-rating__order_by svg{fill:#6b6d76}.mt-select{background:transparent;border:none;color:#6b6d76;font-size:14px;font-weight:400;height:30px;letter-spacing:normal;line-height:1.14}", ""]);
// Exports
module.exports = exports;
